import { useNavigate, useParams } from "react-router-dom";
import UserDashboard from "./users/UserDashboard";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { menuActions } from "../store/menuSlice";
import ReceiptDashboard from "./receipts/ReceiptsMain";
import NotificationsMain from "./notifications/NotificationsMain";
import AnalyticsMain from "./analytics/AnalyticsMain";
import PerformanceMain from "./sub_property_types/PerformanceMain";
import PrizesMain from "./prizes/PrizesMain";
import ApprovedReceipts from "./receipts/ApprovedReceipts";
import ComplaintsMain from "./complaints/ComplaintsMain";
import ReportsMain from "./reports/ReportsMain";
import { NonFiscalReceipts } from "./receipts/non_fiscal_receipts/NonFiscalReceipts";
import { GenerateWinners } from "./GenerateWinners";
import GameRulesTable from "./game_rules/GameRulesTable";
import NotificationTemplates from "./notifications/NotificationTemplates";
import BusinessWinnersMain from "./business_winners/BusinessWinnersMain";

export default function SubCategoryComponent() {
    const { category, subcategory } = useParams(); // category will be 'users' for '/users'

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!category) {
            navigate("/users");
            dispatch(menuActions.changeActiveCategory({ category: "users" }));
            return;
        }
        dispatch(menuActions.changeActiveCategory({ category: category }));
    }, [dispatch, category, navigate]);

    return (
        <>
            {(category === "notifications" && subcategory === 'templates') && <NotificationTemplates />}
            {(category === "winners" && subcategory === "individuals") && <PrizesMain />}
            {(category === "winners" && subcategory === "businesses") && <BusinessWinnersMain />}
        </>
    );
}
